import React from 'react';
import classNames from 'classnames';
import styles from './ColumnTitle.module.scss';

interface ColumnTitleProps {
  titles: string[];
  widths: string[];
  // Même largeur minimale que les lignes : sinon une colonne `auto` n'a pas la même taille ici et
  // dessous, et tous les titres suivants se décalent.
  minWidth?: string;
  // Colonnes triables : la clé de tri de chaque titre, null pour un titre qui ne trie pas.
  sortKeys?: (string | null)[];
  sortKey?: string;
  sortDirection?: 'asc' | 'desc';
  onSort?: (key: string) => void;
}

export const ColumnTitle = ({ titles, widths, minWidth, sortKeys, sortKey, sortDirection, onSort }: ColumnTitleProps) => {
  return (
    <div
      className={classNames(styles.row)}
      style={{ gridTemplateColumns: widths.join(' '), minWidth }}
    >
      {titles.map((title, index) => (
        <div
          key={index}
          className={classNames(styles.column, styles.title)}
        >
          {sortKeys?.[index] && onSort
            ? <button type="button"
                      className={styles.sortButton}
                      title={`Trier par ${title}`}
                      onClick={() => onSort(sortKeys[index] as string)}>
                <span className={styles.sortLabel}>
                  {title}{sortKey === sortKeys[index] && <span className={styles.sortArrow} aria-hidden="true">{sortDirection === 'desc' ? '▼' : '▲'}</span>}
                </span>
              </button>
            : title}
        </div>
      ))}
    </div>
  );
};

export default ColumnTitle;
